import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import whitelogo from "../assets/white_logo.png"; // adjust path based on your structure
const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Properties", path: "/properties" },
    { label: "Services", path: "/services" },
    { label: "Blog", path: "/blog" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms & Conditions", path: "/terms-conditions" },
];



const Footer = () => {
    return (
        <footer className="relative bg-[#2D1F87]/90 text-white overflow-hidden rounded-t-3xl">

            {/* GRADIENT OVERLAY */}
            <div className="absolute inset-0 bg-gradient-to-b from-[#3B2B9A]/60 to-[#1C1360] pointer-events-none rounded-t-3xl"></div>

            <div className="relative mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

                {/* BRAND - Takes more space */}
                <div className="lg:col-span-4 relative group hover:-translate-y-1 hover:scale-[1.02] transition-transform duration-300">
                    <img src={whitelogo} alt="logo" className="h-12" />
                    <p className="mt-4 text-sm text-white/80 leading-relaxed">
                        Landmarks Realty was founded on January 19, 2017, in Noida and serves clients throughout Delhi NCR with trusted real estate consulting and investment guidance. We help homebuyers and investors cut through market insights and make informed property decisions.
                    </p>

                    {/* BADGES */}
                    <div className="mt-5 flex gap-3 flex-wrap">
                        <span className="px-3 py-1 bg-white/10 rounded-full text-xs tracking-wide hover:bg-gradient-to-r hover:from-[#3B2B9A] hover:to-[#5A47D8] transition-all cursor-pointer">
                            RERA Approved
                        </span>
                        <span className="px-3 py-1 bg-white/10 rounded-full text-xs tracking-wide hover:bg-gradient-to-r hover:from-[#3B2B9A] hover:to-[#5A47D8] transition-all cursor-pointer">
                            ISO-Certified
                        </span>
                    </div>
                </div>

                {/* QUICK LINKS - Compact */}
                <div className="lg:col-span-2 relative group hover:-translate-y-1 hover:scale-[1.02] transition-transform duration-300">
                    <h4 className="font-semibold text-lg mb-3">Quick Links</h4>
                    <ul className="space-y-2 text-sm">
                        {quickLinks.map((item, i) => (
                            <li key={i}>
                                <a
                                    href={item.path}
                                    className="text-white/80 hover:text-white transition-all inline-flex items-center gap-2 group"
                                >
                                    <span className="text-[#FFD700] group-hover:translate-x-1 transition-transform">›</span>
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* CONTACT */}
                <div className="lg:col-span-3 relative group hover:-translate-y-1 hover:scale-[1.02] transition-transform duration-300">
                    <h4 className="font-semibold text-lg mb-3">Contact Us</h4>
                    <div className="mt-4 text-sm text-white/80 leading-relaxed space-y-3">
                        <span className="flex items-center gap-3">
                            <FaEnvelope className="text-[#FFD700] flex-shrink-0" />
                            info@landmarksrealty.in
                        </span>

                        <span className="flex items-center gap-3">
                            <FaPhoneAlt className="text-[#FFD700] flex-shrink-0" />
                            +91-93192-19252
                        </span>

                        <span className="flex items-start gap-3">
                            <FaMapMarkerAlt className="text-[#FFD700] mt-1 flex-shrink-0" />
                            G-43, Floor 3, Sector 3, Noida – 201303, Uttar Pradesh, India
                        </span>
                    </div>
                </div>

                {/* NEWSLETTER */}
                <div className="lg:col-span-3 relative group hover:-translate-y-1 hover:scale-[1.02] transition-transform duration-300">
                    <h4 className="font-semibold text-lg mb-3">Stay in the Loop</h4>
                    <p className="mt-3 text-sm text-white/80">
                        Get updates on new property launches, market insights, and limited-time opportunities.
                    </p>

                    <div className="mt-4 flex items-center bg-white/10 backdrop-blur-sm rounded-xl p-1 border border-white/20 transition-all focus-within:ring-2 focus-within:ring-[#3B2B9A]">
                        <input
                            type="email"
                            placeholder="Enter email"
                            className="flex-1 bg-transparent text-sm px-3 py-2 outline-none placeholder-white/60"
                        />
                        <button className="px-4 py-2 bg-white dark:bg-slate-100 text-[#D83B29] rounded-lg font-semibold text-sm hover:opacity-90 transition-all">
                            Join
                        </button>
                    </div>

                    {/* SOCIAL ICONS */}
                    <div className="flex gap-3 mt-6">
                        {[
                            { icon: <FaFacebookF />, link: "https://www.facebook.com/profile.php?id=61583681855346" },
                            { icon: <FaInstagram />, link: "https://www.instagram.com/landmarksrealty_?igsh=a3UzY2dwdHc3bzQ1" },
                            { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/company/landsmarks-realty/?viewAsMember=true" },
                        ].map((item, i) => (
                            <a
                                key={i}
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-3 bg-white/10 backdrop-blur-md rounded-xl text-lg hover:bg-gradient-to-r hover:from-[#3B2B9A] hover:to-[#5A47D8] transition-all transform hover:scale-110"
                            >
                                {item.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            {/* COPYRIGHT */}
            <div className="relative border-t border-white/20 py-4 text-center text-sm text-white/70">
                © {new Date().getFullYear()} Landmarks Realty — All Rights Reserved.
            </div>
        </footer>
    );
};

export default Footer;
